import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/Icons/buttons/arrow-right.svg'


const _hoisted_1 = {
  key: 0,
  img: "",
  src: _imports_0
}


export default /*#__PURE__*/_defineComponent({
  __name: 'aba-button-right',
  props: {
	class: { type: String, default: "active m-2" },
	btnType: { type: String, default: "" },
	btnSize: { type: String, default: "btnLarge" },
	isDisabled: { type: Boolean, default: false },
	isHideImg: { type: Boolean, default: false },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props;

// // Определение эмиттеров событий компонента
const emits = __emit;

function onClick() {
	if (props.isDisabled) return; // Если кнопка заблокирована
	emits("click"); // Вызываем событие click
}

return (_ctx: any,_cache: any) => {
  const _component_aba_button = _resolveComponent("aba-button")!

  return (_openBlock(), _createBlock(_component_aba_button, {
    btnType: props.btnType,
    btnSize: props.btnSize,
    isDisabled: props.isDisabled,
    class: _normalizeClass(props.class),
    onClick: onClick
  }, {
    default: _withCtx(() => [
      (!__props.isHideImg)
        ? (_openBlock(), _createElementBlock("img", _hoisted_1))
        : _createCommentVNode("", true),
      _createTextVNode("  "),
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["btnType", "btnSize", "isDisabled", "class"]))
}
}

})